import axios from "axios";
import apiPath from "./config";

export const _axios = axios.create({baseURL: apiPath});